"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalViewDialogStore = exports.useGlobalFormDialogStore = void 0;
const zustand_1 = require("zustand");
const middleware_1 = require("zustand/middleware");
const types_1 = require("../types");
exports.useGlobalFormDialogStore = (0, zustand_1.create)()((0, middleware_1.devtools)(set => {
    return {
        key: types_1.GlobalDialogKeys.DEFAULT,
        selectedItem: null,
        options: null,
        openDialog(key, selectedItem, options) {
            set({
                key: key,
                options,
                selectedItem,
            });
        },
        closeDialog() {
            set({
                key: types_1.GlobalDialogKeys.DEFAULT,
                options: null,
                selectedItem: null,
            });
        },
    };
}));
exports.useGlobalViewDialogStore = (0, zustand_1.create)()((0, middleware_1.devtools)(set => {
    return {
        key: types_1.GlobalDialogKeys.DEFAULT,
        selectedItem: null,
        options: null,
        openDialog(key, selectedItem, options) {
            set({
                key: key,
                options,
                selectedItem,
            });
        },
        closeDialog() {
            set({
                key: types_1.GlobalDialogKeys.DEFAULT,
                options: null,
                selectedItem: null,
            });
        },
    };
}));
//# sourceMappingURL=index.js.map